<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md10>
      <vue-good-table
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :columns="columns"
        :rows="rows"
        :lineNumbers="true"
        :group-options="{
          enabled: true,
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true
        }"
        :search-options="{
          enabled: true
        }">
        <template slot="table-row" slot-scope="props" >
          <v-avatar
            color="blue lighten-4"
            class="mr-2 mt-2"
            size="30"
            style="cursor: pointer;"
            @click="onRowClick(props.item)"
          >
            <v-icon small>edit</v-icon>
          </v-avatar>
          <v-avatar
            color="red lighten-4"
            class="mr-2 mt-2"
            size="30"
            style="cursor: pointer;"
            @click="deleteItem(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-avatar>
        </template>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <v-avatar
              color="blue lighten-4"
              class="mr-2 mt-2"
              size="30"
              style="cursor: pointer;"
              @click="onRowClick(props)"
            >
              <v-icon small>edit</v-icon>
            </v-avatar>
            <v-avatar
              color="red lighten-4"
              class="mr-2 mt-2"
              size="30"
              style="cursor: pointer;"
              @click="deleteItem(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-avatar>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </v-flex>

    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      height: 0,
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Diet',
          field: 'diet',
          type: 'text'
        },
        {
          label: 'Count',
          field: 'count',
          thClass: 'hidden-sm-and-down',
          tdClass: 'hidden-sm-and-down',
          type: 'number'
        },
        {
          label: 'Action',
          field: 'actions',
          sortable: false,
          html: true,
          width: '50px'
        }
      ],
      rows: [
        {
          mode: 'span',
          label: 'Mammal',
          children: [
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Elephant', diet: 'herbivore', count: 5 },
            { name: 'Cat', diet: 'carnivore', count: 28 },
            { name: 'Dog', diet: 'omnivore', count: 12 },
            { name: 'Dolphin', diet: 'carnivore', count: 9 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Rhino', diet: 'herbivore', count: 5 },
            { name: 'Lion', diet: 'carnivore', count: 28 },
            { name: 'Human', diet: 'omnivore', count: 12 },
            { name: 'Tiger', diet: 'carnivore', count: 9 }
          ]
        },
        {
          mode: 'span',
          label: 'Reptiles',
          children: [
            { name: 'Snake', diet: 'carnivore', count: 40 },
            { name: 'lizard', diet: 'insectivore', count: 34 },
            { name: 'crocodile', diet: 'carnivore', count: 22 },
            { name: 'turtles', diet: 'herbivore', count: 29 }
          ]
        },
        {
          mode: 'span',
          label: 'Fish',
          children: [
            { name: 'Shark', diet: 'carnivore', count: 2 },
            { name: 'koi', diet: 'omnivore', count: 14 },
            { name: 'guppy', diet: 'omnivore', count: 35 }
          ]
        }
      ]
    }
  },

  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 150
      this.height = height + 'px'
    },

    onRowClick (props) {
      console.log(props)
      console.log(props.formattedRow)
      const name = props.formattedRow.name
      console.log(name)
    },

    deleteItem (props) {
      const name = props.formattedRow.name
      const index = this.rows.indexOf(name)
      confirm('Are you sure you want to delete this item?') && this.rows.splice(index, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Table1.vue